import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { containedButtonStyle } from './styles';
import { abyssColors } from '@/theme/colors';
import { textButtonStyle } from '@/theme';

type Props = {
  open: Object;
  title: string;
  message: string;
  buttonText: string;
  handleRemoveUserFromGroup: () => void;
  onClose: () => void;
};

export const ConfirmationDialog = ({
  open,
  title,
  message,
  buttonText,
  handleRemoveUserFromGroup,
  onClose,
}: Props) => {
  return (
    <Dialog open={!!open} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ fontSize: '1.4rem', color: 'primary.main' }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 2 }}>
        <Button onClick={onClose} sx={textButtonStyle}>
          Cancel
        </Button>
        <Button
          sx={{ ...containedButtonStyle, background: abyssColors.error[700] }}
          variant="contained"
          color="error"
          onClick={handleRemoveUserFromGroup}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
